/* global slideUp, slideDown, attachEvent */
// **************************************************
// Program Accordion toggle
// **************************************************

attachEvent('.program-accordion-trigger', 'click', (ev) => {
  const programAccordion = ev.target.closest('.program-accordion');
  const programAccordionContent = programAccordion.querySelector('.program-accordion__content-wrapper');

  if (programAccordion.classList.contains('is-open')) {
    programAccordion.classList.remove('is-open');
    slideUp(programAccordionContent, 300);
  } else {
    programAccordion.classList.add('is-open');
    slideDown(programAccordionContent, 300);
  }

  ev.preventDefault();
});

const joinButton = document.querySelectorAll(('.program-signup'));
const ajaxAction = document.querySelector('main').classList.contains('main-profile-page') ? 'createSignOffAction' : 'createSignOnAction';
joinButton.forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const program = el.closest('.program-accordion');
    const request = new XMLHttpRequest();
    request.open('POST', localData.siteURL, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.send(`action=${ajaxAction}&locationID=${program.getAttribute('data-locationID')}&program=${program.getAttribute('data-programID')}&id=${program.getAttribute('data-user')}`);
    request.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        const response = JSON.parse(request.responseText);
        if (response.data.status === 200) {
          window.location.href = response.data.url;
        }
      }
    };
  });
});
